/**
 * 统计
 */

 import Layout from '@/layout/Layout.vue'

 export default {
  path: '/statistics',
  name: '统计',
  component: Layout,
  children: [
    {
      path: 'product-statistics',
      name: '产品统计',
      component: () => import('@/views/statistics/product-statistics/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'statistics_productStatistics'
      }
    },
    
  ],
}